export default "__VITE_ASSET__CdvHy_LN__"